import * as _ from 'lodash';
import {IMinistryResource} from "../../core/services/MinistryService"
export class MinistryModalComponent implements ng.IComponentOptions {
  public controller: any = MinistryModalController;
  public bindings: any = {
    modalInstance: "<",
    resolve: "<"
  }
  public template: string =
    `<div class="modal-header">
      <button type="button" class="close" ng-click="$ctrl.cancel()" aria-label="Close"><span aria-hidden="true">&times;</span></button>
      <h4 class="modal-title" id="ministryModal">Add Ministry</h4>
    </div>
    <div class="modal-body">
      <form name="ministryForm" class="form-horizontal">
        <div class="form-group">
          <label for="name" class="col-sm-3 control-label">Name</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" id="name" placeholder="Name" ng-model="$ctrl.form.display_name" required>
          </div>
        </div>
        <div class="form-group">
          <label for="code" class="col-sm-3 control-label">Code</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" id="code" placeholder="Code" ng-model="$ctrl.form.code" required>
          </div>
        </div>
        <div class="form-group">
          <label for="desc" class="col-sm-3 control-label">Description</label>
          <div class="col-sm-9">
            <textarea class="form-control" placeholder="Description" ng-model="$ctrl.form.description"></textarea>
          </div>
        </div>
        <div class="form-group">
          <label for="desc" class="col-sm-3 control-label">Logo</label>
          <div class="col-sm-9">
          <img style="margin:5px;max-height:100px;" ngf-thumbnail="$ctrl.form.file">
          <img style="margin:5px;max-height:100px;" ng-show="!$ctrl.form.file && $ctrl.form.logo" ng-src="/storage/{{$ctrl.form.logo}}">
          <div class="drop-box" ngf-select ngf-drop ngf-drag-over-class="'dragover'" ngf-pattern="'.jpg,.png,.jpeg,.gif'" accept=".jpg,.png,.jpeg,.gif" ng-model="$ctrl.form.file">Select or drop your image here</div>
          <div ngf-no-file-drop>File Drag/Drop is not supported for this browser</div>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <p class="text-warning" ng-show="$ctrl.error">Ministry failed to save, please try again.</p>
      <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()">Close</button>
      <button type="button" class="btn btn-primary" ng-click="ministryForm.$valid && $ctrl.saveMinistry()" ng-disabled="$ctrl.submitting">Save changes</button>
    </div>`;
}
export interface IMinistry extends ng.resource.IResource<any> {
  name: string;
  display_name: string;
  code: string;
  agencies: any;
  description: string;
  state: string;
  createdOn: Date;
}
export class MinistryModalController {
  public static $inject: Array<any> = ["MinistryService", "$timeout", "Upload"];
  public modalInstance: ng.ui.bootstrap.IModalServiceInstance;
  public resolve: any;
  public form:any;
  public isEdit: boolean;
  public submitting: boolean;
  public error: boolean;
  constructor(private MinistryService: IMinistryResource, private $timeout:ng.ITimeoutService, private Upload: ng.angularFileUpload.IUploadService){
    $timeout(() => {
      if (this.resolve.ministry) {
        this.isEdit = true;
        this.form = this.resolve.ministry;
      }
      else
        this.isEdit = false;
    })
  }
  public cancel() {
    this.modalInstance.dismiss("canceled");
  }
  public saveMinistry() {
    this.submitting = true;
    let request:any = {
      url: "api/ministry",
      method: "POST",
      arrayKey: ''
    }
    if (this.isEdit) {
      request.url = `api/ministry/${this.form._id}`;
      request.method = "PUT";
    }
    else {
      this.form.name = this.form.display_name.split(" ").join("_");
    }
    request.data = _.omit(this.form,['$promise','$resolved', '$delete','$query', '$get', '$remove', '$save','$update', 'toJSON']);
    this.Upload.upload(request)
    .then(resp => {
      this.submitting = false;
      this.modalInstance.close(resp.data);
    })
    .catch(err => {
      console.log(err)
      this.error = true;
      this.submitting = false;
    })
  }
}
